import { Map as ImmutableMap } from 'immutable';
import * as ActionTypes from '../../actions/ActionTypes';
import { HELPFUL_RATING_VALUE, UNHELPFUL_RATING_VALUE } from '../../constants/ArticleFeedbackConstants';
export default function articleFeedbackMaxCounts(
// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
state = new ImmutableMap({
  [HELPFUL_RATING_VALUE]: 0,
  [UNHELPFUL_RATING_VALUE]: 0
}), {
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_ARTICLE_FEEDBACK_MAX_COUNTS_SUCCESS:
      return state.set(payload.ratingValue, payload.count);
    default:
      return state;
  }
}